import request from '@/utils/request'

// 查询列表 通过编号
export function getBannerListReq(query) {
  return request({
    url: '/api/banner/getBannerList',
    method: 'GET',
    params: query , //params修改为data
  })
}
//查询banner数据
export function getBannerInfoReq(query) {
  return request({
    url: '/api/banner/getBannerInfo',
    method: 'GET',
    params: query , //params修改为data
  })
}//查询banner数据
export function getPromotionReq(query) {
  return request({
    url: '/api/promotion/getPromotion',
    method: 'GET',
    params: query , //params修改为data
  })
}
